import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button, FormControl, FormLabel, Select, useToast } from '@chakra-ui/react';
import PerguntasController from 'controllers/Perguntas/PerguntasController';

export function PatternForm({ questionId, onClose }) {
  const { register, handleSubmit } = useForm();
  const toast = useToast()

  const [patterns, setPatterns] = useState([])

  async function getPattern() {
    const response = await PerguntasController.ListPerguntasPattern()

    if(!response) {
      console.error("Não foi possível encontrar padrões")
      return null
    }

    setPatterns(response)
  }

  const onSubmit = (data) => {
    console.log(data)
    const response = PerguntasController.ReProc(questionId, 2, "", data.regex_option)

    if(!response) {
      toast({
        title: 'Erro ao processar',
        description: response.msg,
        status: 'error',
        duration: 9000,
        isClosable: true,
      })

      return
    }

    onClose()
    toast({
      title: 'Processado com sucesso!',
      description: response.msg,
      status: 'success',
      duration: 9000,
      isClosable: true,
    })
  };

  useEffect(() => {
    getPattern()
  }, [])

  return (
    <Box maxW="md" mx="auto" mt={5} p={5} borderWidth={1} borderRadius="lg">
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl id="regex_option" mb={4}>
          <FormLabel>Padrão</FormLabel>
          <Select {...register("regex_option")} placeholder="Selecione um padrão">
            {patterns.length > 0 && patterns.map(pattern => (
              <option value={pattern?.id} key={pattern?.id}>{pattern?.name}</option>
            ))}
          </Select>
        </FormControl>
        <Button type="submit" colorScheme="blue">Cadastrar</Button>
      </form>
    </Box>
  );
}
